import { FormikErrors } from 'formik';
import i18n from '../../../../../i18n';

type TFValidate = (p: Record<string, string | null>) => FormikErrors<Record<string, string | null>>;

export const validate: TFValidate = (values) => {
  const errors: FormikErrors<Record<string, string | null>> = {};
  const url =
    /^((https?:\/\/|www\.))[a-z0-9а-я]+([\-_.]{1}[a-z0-9а-я]+)*\.[a-zа-я]{2,20}(:[0-9]{1,5})?(\/?.*)?$/m;
  const macrosReg = /^(\{\w+\}\s?)+$/gi;
  const macrosReg2 = /^(\{\w+\}\s?)+$/gi;

  if (values.erid) {
    const regExp = /^[a-zA-Z0-9]+$/;
    if (!regExp.test(values.erid)) {
      errors.erid = i18n.t('errors.err_value');
    }
  }

  if (values.link && !url.test(values.link)) {
    if (!macrosReg.test(values.link)) {
      errors.link = i18n.t('errors.err_http_lorem');
    }
  }
  if (values.link && values.link.length >= 1024) {
    errors.link = i18n.t('errors.limitsym');
  }

  if (values.extension_link && !url.test(values.extension_link)) {
    if (!macrosReg2.test(values.extension_link)) {
      errors.extension_link = i18n.t('errors.err_http_lorem');
    }
  }
  if (values.extension_link && values.extension_link.length >= 1024) {
    errors.extension_link = i18n.t('errors.limitsym');
  }

  if (values.adomain && values.adomain.length >= 1024) {
    errors.adomain = i18n.t('errors.limitsym');
  }

  if (values.pixel && values.pixel.length > 0 && !url.test(values.pixel)) {
    errors.pixel = i18n.t('errors.err_http_lorem2');
  }

  if (values.pixel && values.pixel.length > 0 && values.pixel.length >= 1024) {
    errors.pixel = i18n.t('errors.limitsym');
  }

  if (
    values.click_audit_pixel &&
    values.click_audit_pixel.length > 0 &&
    !url.test(values.click_audit_pixel)
  ) {
    errors.click_audit_pixel = i18n.t('errors.err_http_lorem2');
  }

  if (
    values.click_audit_pixel &&
    values.click_audit_pixel.length > 0 &&
    values.click_audit_pixel.length >= 1024
  ) {
    errors.click_audit_pixel = i18n.t('errors.limitsym');
  }

  if (values.iurl && values.iurl.length > 0 && !url.test(values.iurl)) {
    errors.iurl = i18n.t('errors.err_http_lorem2');
  }

  if (values.iurl && values.iurl.length > 0 && values.iurl.length >= 1024) {
    errors.iurl = i18n.t('errors.limitsym');
  }

  if (
    values.pixel_additional &&
    values.pixel_additional.length > 0 &&
    !url.test(values.pixel_additional)
  ) {
    errors.pixel_additional = i18n.t('errors.err_http_lorem2');
  }

  if (
    values.pixel_additional &&
    values.pixel_additional.length > 0 &&
    values.pixel_additional.length >= 1024
  ) {
    errors.pixel_additional = i18n.t('errors.limitsym');
  }

  return errors;
};